module.exports = __webpack_public_path__ + "media/images/low-battery-0ae8bb72f3eaa9c6e6371c6d3d7ce6e9.png";